module.exports = __webpack_public_path__ + "img/gateway-and-embedded.f7cc85b1.jpg";